import type { AllRouteEndpoints } from "../routeTypes";
export const internalUserGroupsInternalUserGroupCreateCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/internal_user_groups_data",
  "/internal_user_groups/internal_user_groups_data_v2",
];
